import { createMainAppMicroserviceInstance } from '@servicetitan/cp-api';
import { injectable } from '@servicetitan/react-ioc';
import { action, makeObservable, observable, runInAction } from 'mobx';
import {
    EstimateContainerType,
    EstimateContainerWebModel,
} from '../../dashboard/api/portal-dashboard.api';
import { PortalEstimates } from '../../dashboard/api/portal-estimates.api';

@injectable()
export class ContractStore {
    @observable contractsExist = false;
    @observable loaded = false;

    private estimates: PortalEstimates;

    constructor() {
        makeObservable(this);
        this.estimates = new PortalEstimates(
            createMainAppMicroserviceInstance('/v1/customerportal2/estimates', '/api/cp/estimates')
        );
        this.loadContractsExist();
    }

    @action async loadContractsExist() {
        try {
            const { data } = await this.estimates.getEstimateContainers();
            const hasContracts = (data as unknown as EstimateContainerWebModel[]).some(
                container =>
                    container.estimateContainerType === EstimateContainerType.ContractProposal
            );
            runInAction(() => {
                this.contractsExist = hasContracts;
                this.loaded = true;
            });
        } catch {
            runInAction(() => {
                this.contractsExist = false;
                this.loaded = true;
            });
        }
    }
}
